export const OrganiserPages = {
  EVENT_LIST: 'EVENT_LIST',
  ORGANISER_SETTINGS: 'ORGANISER_SETTINGS',
  START_LIST: 'START_LIST',
  LATEST_ENTRIES: 'LATEST_ENTRIES',
};
